module.exports = __webpack_public_path__ + "img/error.982b8554.png";